
import { playgrounds } from '../../../mocks/parks';

export default function PlaygroundsSection() {
  return (
    <section id="playgrounds" className="py-20 bg-amber-50/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="inline-flex items-center gap-2 bg-amber-100 px-3 py-1 rounded-full mb-3">
              <i className="ri-gamepad-line text-amber-600 text-sm"></i>
              <span className="text-amber-700 text-xs font-semibold">
                Family Friendly
              </span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Playgrounds</h2>
            <p className="text-gray-500">
              Safe, accessible play spaces for children of all ages and abilities
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {playgrounds.map((pg) => (
            <div
              key={pg.id}
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={pg.image}
                  alt={pg.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-amber-500 text-white text-xs font-semibold rounded-full">
                    {pg.ageRange}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  <span className="text-xs font-semibold text-gray-800">
                    {pg.rating}
                  </span>
                </div>
              </div>

              <div className="p-5">
                <h3 className="font-bold text-gray-900 mb-1 group-hover:text-amber-600 transition-colors">
                  {pg.name}
                </h3>
                <p className="text-sm text-gray-500 line-clamp-2 mb-3">
                  {pg.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {pg.features.slice(0, 4).map((f) => (
                    <span
                      key={f}
                      className="px-2 py-0.5 bg-amber-50 text-amber-700 text-xs rounded-full font-medium"
                    >
                      {f}
                    </span>
                  ))}
                  {pg.features.length > 4 && (
                    <span className="px-2 py-0.5 bg-gray-100 text-gray-500 text-xs rounded-full font-medium">
                      +{pg.features.length - 4}
                    </span>
                  )}
                </div>

                {/* Amenity Icons */}
                <div className="flex items-center gap-2 mb-4">
                  {pg.amenities.includes('Restrooms') && (
                    <div
                      className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full"
                      title="Restrooms"
                    >
                      <i className="ri-building-4-line text-gray-500 text-xs"></i>
                    </div>
                  )}
                  {pg.amenities.includes('ADA Accessible') && (
                    <div
                      className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full"
                      title="ADA Accessible"
                    >
                      <i className="ri-wheelchair-line text-gray-500 text-xs"></i>
                    </div>
                  )}
                  {pg.amenities.includes('Shade Structures') && (
                    <div
                      className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full"
                      title="Shade"
                    >
                      <i className="ri-umbrella-line text-gray-500 text-xs"></i>
                    </div>
                  )}
                  {pg.amenities.includes('Parking') && (
                    <div
                      className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full"
                      title="Parking"
                    >
                      <i className="ri-parking-box-line text-gray-500 text-xs"></i>
                    </div>
                  )}
                  {pg.amenities.includes('Water Fountain') && (
                    <div
                      className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full"
                      title="Water Fountain"
                    >
                      <i className="ri-drop-line text-gray-500 text-xs"></i>
                    </div>
                  )}
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1 text-xs text-gray-400">
                    <i className="ri-map-pin-line"></i>
                    <span className="truncate max-w-[180px]">{pg.address}</span>
                  </div>
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      pg.address
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-emerald-600 hover:text-emerald-700 text-sm font-medium whitespace-nowrap cursor-pointer"
                  >
                    Directions <i className="ri-arrow-right-up-line"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
